export function isQuoteNetworkFailure(error: unknown): boolean {
  return error instanceof SyntaxError || (error instanceof TypeError
    && /load failed|failed to fetch|networkerror|network request failed|connection lost/i.test(error.message));
}

function pause(signal: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    const aborted = () => { clearTimeout(timer); reject(new DOMException("Aborted", "AbortError")); };
    const timer = setTimeout(() => { signal.removeEventListener("abort", aborted); resolve(); }, 2500);
    if (signal.aborted) aborted();
    else signal.addEventListener("abort", aborted, { once: true });
  });
}

/** Never repeat the POST: reconnect by reading the same account-owned result. */
export async function recoverQuoteResponse<T>(
  operation: () => Promise<T>,
  lookup: () => Promise<T | null>,
  signal: AbortSignal,
  onRecover: () => void,
): Promise<T> {
  try {
    return await operation();
  } catch (error) {
    if (!isQuoteNetworkFailure(error) || signal.aborted) throw error;
    onRecover();
    while (!signal.aborted) {
      try {
        const result = await lookup();
        if (result !== null) return result;
      } catch (lookupError) {
        if (!isQuoteNetworkFailure(lookupError)) throw lookupError;
      }
      await pause(signal);
    }
    throw new DOMException("Aborted", "AbortError");
  }
}

export function isFixedQuoteExample(
  enabled: boolean, fileCount: number, description: string,
  samples: { description: string }[] | undefined,
): boolean {
  return enabled && fileCount === 0 && !!description && !!samples?.some(sample => sample.description === description);
}
